import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { inline } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';

interface LabelProps {
  flex?: boolean;
}

interface StyledCheckboxProps {
  checked?: boolean;
}

export const Label = styled.label<LabelProps>`
  ${font.sm};
  ${(props) =>
    props.flex &&
    `
           flex-grow: 1;
           flex-basis: 0;
        `}
`;

export const HiddenCheckbox = styled.input`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
`;

export const StyledCheckbox = styled.span<StyledCheckboxProps>`
  ${inline._1x};
  font-size: 16px;
  line-height: 1;
  background-color: ${colors['$hpx-white']};
  color: ${colors['$hpx-white']};
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;

  ${(props) =>
    props.checked &&
    `
        background-color: ${colors['$hpx-teal-500']};
    `}

  ${HiddenCheckbox}:focus + & {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: 5px;
  }
`;
